import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TextArea, Popup } from '_atoms';
import { Typography } from '_atoms/Typography';
import { BUTTON_TEXT } from 'constants/text';

interface WithdrawUserData {
  first_name_latin?: string;
  last_name_latin?: string;
  first_name_local?: string;
  last_name_local?: string;
  speciality?: string | null;
}

interface PopupWithdrawProps {
  open: boolean;
  onClose: () => void;
  onWithdraw: (comment: string) => void;
  userData?: WithdrawUserData;
}

export const PopupWithdraw: React.FC<PopupWithdrawProps> = ({ open, onClose, onWithdraw, userData = {} }) => {
  const { t } = useTranslation();
  const { first_name_latin, last_name_latin, first_name_local, last_name_local, speciality } = userData;

  const [comment, setComment] = useState('');
  const onChangeComment = (e: React.ChangeEvent<HTMLTextAreaElement>) => setComment(e.target.value);
  const onWithdrawClick = () => onWithdraw(comment);

  useEffect(() => {
    if (!open) setComment('');
  }, [open]);

  return (
    <Popup
      open={open}
      className="mobile-full-size"
      title={t('translation:popup_withdraw.title')}
      cancelButtonProps={{
        onClick: onClose,
        children: BUTTON_TEXT.CANCEL,
      }}
      okButtonProps={{
        children: BUTTON_TEXT.WITHDRAW,
        onClick: onWithdrawClick,
      }}
    >
      <div className="user-info">
        <Typography.Text className="user-info__title">
          {first_name_latin} {last_name_latin}
        </Typography.Text>
        <Typography.Caption className="user-info__subtitle">
          {first_name_local} {last_name_local}
        </Typography.Caption>
        <Typography.Caption className="user-info__subtitle">{speciality}</Typography.Caption>
      </div>
      <TextArea
        label={t('translation:popup_withdraw.label_comment')}
        value={comment}
        maxLength={6000}
        placeholder={t('translation:popup_withdraw.placeholder_comment')}
        onChange={onChangeComment}
      />
    </Popup>
  );
};
